export default __webpack_public_path__ + "static/media/6.4.da290c70.mp3";